import { createStore } from "vuex";

const store = createStore({
    state: {
        zoom: 1
    }
})

export default store;